import { useFeatureStore } from '~/stores/useFeatureStore';
import type { FeatureName } from '~/types/feature.types';

export function useFeatures () {
  const featureStore = useFeatureStore();

  const isFeatureEnabled = (featureName: FeatureName): boolean => {
    return featureStore.isEnabled(featureName);
  };

  const refreshFeatures = async () => {
    return await featureStore.updateFeatures();
  };

  const ensureFeatureEnabled = async (featureName: FeatureName): Promise<boolean> => {
    if (!featureStore.featuresLoaded.value) {
      await featureStore.updateFeatures();
    }
    return featureStore.isEnabled(featureName);
  };

  return {
    isFeatureEnabled,
    ensureFeatureEnabled,
    refreshFeatures,
    features: featureStore.features,
    featuresLoaded: computed(() => featureStore.featuresLoaded.value),
  };
}